export function buildExamFormData({
     nameEn,
     nameAr,
     descriptionEn,
     descriptionAr,
     courseId,
     durationMinutes,
     passPercentage,
     maxAttempts,
}) {
     const formData = new FormData();
     formData.append('name_en', nameEn);
     formData.append('name_ar', nameAr);
     formData.append('description_en', descriptionEn);
     formData.append('description_ar', descriptionAr);
     formData.append('course_id', courseId);
     if (durationMinutes != null && durationMinutes !== '') {
          formData.append('duration_minutes', durationMinutes);
     }
     if (passPercentage != null && passPercentage !== '') {
          formData.append('pass_percentage', passPercentage);
     }
     if (maxAttempts != null && maxAttempts !== '') {
          formData.append('max_attempts', maxAttempts);
     }
     return formData;
}
